import { render } from "./about-page.vue?vue&type=template&id=0724e9c3&ts=true"
import script from "./about-page.vue?vue&type=script&lang=ts"
export * from "./about-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__